module.exports = __webpack_public_path__ + "static/media/getDemoNotification.d49fdd03.png";